module["exports"] = [
  "#{street_name} #{building_number}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/address/street_address.js
 ** module id = 836
 ** module chunks = 0
 **/